module.exports = __webpack_public_path__ + "static/media/green-tick.fe0aa864.svg";